module.exports = __webpack_public_path__ + "img/HardwiredTracker.35d8eeca.png";